import { render, staticRenderFns } from "./UserFeedback.vue?vue&type=template&id=b7bd334c&scoped=true"
import script from "./UserFeedback.vue?vue&type=script&lang=js"
export * from "./UserFeedback.vue?vue&type=script&lang=js"
import style0 from "./UserFeedback.vue?vue&type=style&index=0&id=b7bd334c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bd334c",
  null
  
)

export default component.exports